import { render } from "./HomeiconAndroid.vue?vue&type=template&id=5b78776d&scoped=true"
import script from "./HomeiconAndroid.vue?vue&type=script&lang=js"
export * from "./HomeiconAndroid.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-5b78776d"

export default script